import { JetView } from 'webix-jet'; // Importing JetView from webix-jet framework
import Filter from 'views/partner/products2/categories-products/filter'; // Importing Filter component
import Table from 'views/partner/products2/categories-products/table'; // Importing Table component
import { devConfig } from 'config/config'; // Importing development configuration

/**
 * CategoriesProductsView class extending JetView
 */
export default class CategoriesProductsView extends JetView {
    /**
     * Configures the view layout
     * @returns {Object} Layout configuration
     */
    config() {
        const _ = this.app.getService('locale')._; // Localization service
        const theme = this.app.config.theme; // Current theme configuration
        const left = {
            rows: [Filter, Table], // Layout containing Filter and Table components
        };
        webix.ui.fullScreen(); // Set the UI to full screen mode

        // Check permissions for adding categories products
        if (!devConfig.getPermAction('partnerProducts2CategoriesProducts', 'Add')) {
            this.show('./partner.products2.partnersCategories'); // Redirect if no permission
        } else {
            return {
                id: 'a5', // Unique identifier for the view
                type: 'clean', // Clean view type
                view: 'form', // Form view
                scroll: 'y', // Enable vertical scrolling
                rows: [
                    {
                        responsive: 'a5', // Responsive layout
                        type: 'wide', // Wide layout type
                        cols: [left], // Columns containing the left layout
                    },
                ],
            };
        }
    }

    /**
     * Initializes the view
     */
    init() {}
}

// FILE DOCUMENTED
